<template>
  <div>
    <div v-if="!is_variation_enable">
      <v-row align="center">
        <v-col
          :align="isMobile ? 'left' : 'right'"
          cols="12"
          xs="12"
          sm="12"
          md="3"
          lg="2"
          xl="2"
        >
          <p style="font-weight: bold; margin-bottom: 0!important; font-size: 15px;">Variations:</p>
        </v-col>
        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="7"
          lg="6"
          xl="6"
        >
          <div
            class="d-flex justify-center align-center form-custom"
            @click="enable_variation"
          >
            <p style="font-size: 14px; font-weight: bold; margin-bottom: 0!important; color: #1976D2">Enable variations</p>
          </div>
        </v-col>
      </v-row>
    </div>

    <div v-else>
      <!-- Variation 1 -->
      <div>
        <VariationForm
          title="Variation 1"
          :variation_name="variation1_name"
          :variation_options="variation1_options"
          @disable_variation="disable_variation"
          @update_variation="update_variation1"
          @variation_change="variation1_change"
          @delete_variation_option="delete_variation1_option"
          @update_variation_option="update_variation1_option"
          @add_variation="add_variation1"
        ></VariationForm>
      </div>

      <div
        v-if="!is_variation2_enable"
        class="form-spacing"
      >
        <v-row align="center">
          <v-col
            :align="isMobile ? 'left' : 'right'"
            cols="12"
            xs="12"
            sm="12"
            md="3"
            lg="2"
            xl="2"
          >
            <p style="font-weight: bold; margin-bottom: 0!important; font-size: 15px;">Variation 2:</p>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="7"
            lg="6"
            xl="6"
          >
            <div
              class="d-flex justify-center align-center form-custom"
              @click="enable_variation2"
            >
              <p style="font-size: 14px; font-weight: bold; margin-bottom: 0!important; color: #1976D2">Add</p>
            </div>
          </v-col>
        </v-row>
      </div>

      <!-- Variation 2 -->
      <div v-else>
        <div class="form-spacing">
          <VariationForm
            title="Variation 2"
            :variation_name="variation2_name"
            :variation_options="variation2_options"
            @disable_variation="disable_variation2"
            @update_variation="update_variation2"
            @variation_change="variation2_change"
            @delete_variation_option="delete_variation2_option"
            @update_variation_option="update_variation2_option"
            @add_variation="add_variation2"
          ></VariationForm>
        </div>
      </div>

      <!-- Variation table -->

    </div>
  </div>
</template>

<script>
import RowTextField from '../components/RowTextField.vue';
import VariationForm from '../components/VariationForm.vue';

export default {
  props: {
    variation1_name: String,
    variation1_name_error_message: String,
    variation1_options: Array,
    variation2_name: String,
    variation2_name_error_message: String,
    variation2_options: Array,
    read_only: Boolean,
  },
  components: {
    RowTextField,
    VariationForm
  },
  data: function () {
    return {
      is_variation_enable: false,
      is_variation2_enable: false,
    };
  },
  methods: {
    update_variation1_option(value) {
      var temp_value = this.variation1_options[value.index];
      temp_value.name = value.value;
      var data = {
        value: temp_value,
        index: value.index
      };
      this.$emit('input_variation1_option', data);
    },
    variation1_change(value) {
      this.$emit('variation1_change', value);
    },
    update_variation1(value) {
      this.$emit('input_variation1', value);
    },
    add_variation1() {
      this.$emit('add_variation1');
    },
    delete_variation1_option(index) {
      this.$emit('delete_variation1_option', index);
    },
    enable_variation() {
      this.is_variation_enable = true;
      this.$emit('enable_variation');
    },
    disable_variation() {
      this.is_variation_enable = false;
      this.$emit('disable_variation');
    },
    update_variation2_option(value) {
      var temp_value = this.variation2_options[value.index];
      temp_value.name = value.value;
      var data = {
        value: temp_value,
        index: value.index
      };
      this.$emit('input_variation2_option', data);
    },
    variation2_change(value) {
      this.$emit('variation2_change', value);
    },
    update_variation2(value) {
      this.$emit('input_variation2', value);
    },
    add_variation2() {
      this.$emit('add_variation2');
    },
    delete_variation2_option(index) {
      this.$emit('delete_variation2_option', index);
    },
    enable_variation2() {
      this.is_variation2_enable = true;
      this.$emit('enable_variation2');
    },
    disable_variation2() {
      this.is_variation2_enable = false;
      this.$emit('disable_variation2');
    },
  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return true;
        case "lg":
          return false;
        case "xl":
          return false;
        default:
          return false;
      }
    },
  },
}
</script>

<style scoped>
.form-custom {
  height: 35px;
  border: 2px dashed #1976d2;
  border-radius: 5px;
}

.form-custom:hover {
  background-color: #e3f2fd;
  cursor: pointer;
}

.form-spacing {
  margin-top: 25px;
  margin-bottom: 25px;
}
</style>